<template>
    <div class="top-menu-column">
        <span class="column-name" v-if="name">{{ name }}</span>
        <div class="items">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon"],
    components: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>
.top-menu-column {
    padding: 24px;
    
    .column-name {
        font-weight: 600;
        font-size: 1.1em;
    }
    .items {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
</style>